import axios from "../reducers/authinterceptor";
const API_URL = process.env.REACT_APP_LOCALHOST_URL + "/api/auth/";
const register = (username, email, password) => {
  return axios.post(API_URL + "signup", {
    username,
    email,
    password,
  });
};
const login = (username, password) => {
  return axios
    .post(API_URL + "signin", {
      username,
      password,
    })
    .then((response) => {
      if (response.data.accessToken) {
        localStorage.setItem("user", JSON.stringify(response.data.user));
        localStorage.setItem("menu", JSON.stringify(response.data.menu));
      }
      return response.data;
    });
};

const logout = (message) => {
  console.log("LOGGING OUT");
  localStorage.clear();
  window.location.href = "/login?message=" + message;
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};

const getRegistration = async (id) => {
  try {
    const response = await axios.get(API_URL + "register/" + id);
    console.log(response);
    return response.data;
  } catch(error) {
    console.log(error.response.data.message);
    return {error: true, message: error.response.data.message};
  }
};

const AuthService = {
  register,
  login,
  logout,
  getCurrentUser,
  getRegistration
};
export default AuthService;